import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'

Vue.use(Router)

export const constantRoutes = [ 
    {
    path: '/',
    name: 'Index',
    component: Index
    }
]

export default new Router({
    mode: 'history', // 去掉url中的#
    routes: constantRoutes
})
